import i18next from 'i18next';
import { RoleEnum } from 'src/api';
import { StellantisQuoteRequestDTO } from 'src/api/models/StellantisDTO';
import { StellantisConstant } from 'src/components/Stellantis';
import { formatDate } from 'src/utils';

export function buildExportData(
	data: StellantisQuoteRequestDTO[]
): (string | number)[][] {
	const headers = [
		i18next.t('requestDate'),
		i18next.t('dealer_or_segnalatore'),
		i18next.t('user'),
		i18next.t('marca'),
		i18next.t('modello'),
		i18next.t('allestimento'),
		i18next.t('annual_km'),
		i18next.t('duration'),
		i18next.t('downpayment'),
		i18next.t('rca'),
		i18next.t('kasko'),
		i18next.t('theft_fire'),
		i18next.t('tyres'),
		i18next.t('replacement_car'),
		i18next.t('optionals'),
		i18next.t('rental_company'),
		i18next.t('rental_fee'),
		i18next.t('provvigioni'),
		i18next.t('gestione'),
		i18next.t('processing_time'),
	];

	const rows = data.filter(Boolean).map((item) => {
		const q = item.quote;

		const rawDate = item.requestDate;
		const formattedDate = rawDate
			? formatDate(rawDate + 'Z', 'it-IT', true)
			: '';

		const gommeInfo = q?.gommeYN
			? `${q?.tipoGomma?.toUpperCase()}  (${
					q?.gommeIllimitateYN
						? 'Illimitate'
						: (q?.numTrenoGommeEstive || 0) +
						  ' estive, ' +
						  (q?.numTrenoGommeInvernali || 0) +
						  ' invernale'
			  })`
			: i18next.t('no');

		const replacementCar = q?.autoSostitutivaYN
			? StellantisConstant.vetturaSostitutivaAllOptions.find(
					(opt) => opt.value == q?.autoSostitutivaGruppo
			  )?.label || q?.autoSostitutivaGruppo?.toUpperCase()
			: i18next.t('no');

		const canoneLabel =
			q?.tipoCliente === 'privato'
				? i18next.t('canone_with_iva')
				: i18next.t('canone_without_iva');

		const dealerOrSegnalatore =
			item.requestedByRole === RoleEnum.SEGNALATORE
				? `${item.dealer} (Segnalatore)`
				: item.dealer ?? '';

		return [
			formattedDate === 'Invalid Date' ? rawDate : formattedDate,
			dealerOrSegnalatore,
			item.requestedByFullname || item.requestedBy,
			q?.marca ?? '',
			q?.modello ?? '',
			q?.allestimento ?? '',
			q?.kmAnnui ?? '',
			(q?.durata ?? '') + (q?.durata != null ? ' ' + i18next.t('months') : ''),
			q?.anticipoNoIva != null ? q.anticipoNoIva + '€' : '',
			q?.rcaPenaleRisarcitoria != null ? q.rcaPenaleRisarcitoria + '€' : '',
			q?.kaskoFranchigia != null ? q.kaskoFranchigia + '€' : '',
			q?.incendioFurtoScopertoPerc != null
				? q.incendioFurtoScopertoPerc + '%'
				: '',
			gommeInfo,
			replacementCar ?? '',
			q?.optionals?.length ? i18next.t('yes') : i18next.t('no'),
			q?.noleggiatore || '',
			(q?.canone ?? 0) + '€' + ' ' + canoneLabel,
			q?.provvigioni ?? 0,
			(item.assignedToFullname || item.assignedTo) ?? '',
			item.processingTime ?? '',
		];
	});

	return [headers, ...rows];
}
